<template>
  <div class="">
    <div v-if="!isHorizontal">{{ field.name }}</div>
    <div v-for="(group, index) in groups" :key="index+'textField'" class="d-flex align-items-center">
      <div class="w-100">
        <div class="d-flex justify-content-between align-items-center flex-row-reverse">
          <a v-if="showBtnGroup && !isFieldDisabled" role="button" @click="removeGroup(index)" class="btn-remove-group-horizontal mb-1 align-self-end">Remove</a>
          <b-form-input
            style="min-width: 200px"
            :id="uniqueId+index"
            v-model="group[field.name]"
            @input="onChange(index)"
            :disabled="isFieldDisabled"
            :type="isTypeNumber ? 'number' : 'text'"
            :maxlength="maxLength"
          />
        </div>
        <div class="d-flex flex-column">
          <span class="textHint" v-if="hint">{{ hint }}</span>
          <span class="text-error" v-if="error">{{ error }}</span>
        </div>
        <hr>
      </div>
    </div>
    <button
      v-if="showBtnGroup && !isFieldDisabled"
      @click="addGroup"
      class="addGroupBtn"
      type="button" >
        <span>+ Input</span>
    </button>
  </div>
</template>
<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";

export default {
  components: {
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    lastFacilitySelected: {
      type: Object,
      default: () => ({}),
    },
    lastRegionOfFacilitySelected: {
      default: null,
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const groups = ref([{[props.field.originalName]: ""}]);
    const showBtnGroup = ref(false);
    const isFieldDisabled = ref(false);
    const hint = ref("");
    const maxLength = ref(null);
    const isTypeNumber = ref(false);
    const error = ref(null);


    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isFieldDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    watch(
      () => props.lastRegionOfFacilitySelected,
      (newValue, oldValue) => {
        setKeywordConfig()
      },
      { immediate: true }
    );

    onMounted(async () => {
      if(props.field.type === "placeholder") {
        isFieldDisabled.value = true
        groups.value[0][props.field.originalName] = props?.field?.options?.fieldTypeCfg?.data[0]?.value;
        onChange(0)
        return;
      }
      isFieldDisabled.value = props.isFormDisabled
      showBtnGroup.value = props?.field?.options?.isGroup;
      hint.value = props?.field?.options?.fieldTypeCfg?.data[0]?.hint;
      maxLength.value = props?.field?.options?.fieldTypeCfg?.data[0]?.maxLength;
      hint.value =  `${hint.value ?? ""} ${maxLength.value  ? " - Máximo " + maxLength.value + " caracteres." : ""}`
      isTypeNumber.value = props?.field?.options?.fieldTypeCfg?.data[0]?.isTypeNumber;
      const isReadOnly = props?.field?.options?.fieldTypeCfg?.data[0]?.readOnly;
      if(isReadOnly) {
        isFieldDisabled.value = true
      }
    });

    function onChange(index) {
      const result = showBtnGroup.value ? groups.value : groups.value[index][props.field.originalName]
      emit("updateData", props.field, result);
    }

    function setKeywordConfig() {
      if(props.field.type === "keyword") {
        isFieldDisabled.value = true
        const regions = props.field.options?.fieldTypeCfg?.data &&  props.field.options?.fieldTypeCfg?.data.length > 5 ? props.field.options?.fieldTypeCfg?.data : []
        const region = regions.find(r => normalizeStateName(r.state) == normalizeStateName(props.lastRegionOfFacilitySelected))
        const keyword = region?.keyword
        groups.value[0][props.field.name] = keyword
        emit("updateData", props.field, keyword);
      }
    }

    function normalizeStateName(name) {
      if (!name) return ''
    
      return name
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim()
    }


    function addGroup() {
      groups.value.push({[props.field.originalName]: ""})
    }

    function removeGroup(index) {
      if(groups.value.length === 1) return;
      groups.value.splice(index, 1);
    }


    return {
      uniqueId,
      groups,
      showBtnGroup,
      isFieldDisabled,
      maxLength,
      isTypeNumber,
      error,
      hint,
      onChange,
      addGroup,
      removeGroup
    }
  }
}
</script>
<style scoped lang="scss">
.dark-layout {
  .labelForSelect .textHint {
    color: #fff
  }
  .addGroupBtn {
    border-color: #fff;
  }
  .textHint {
    color: #d7d7d7
  }
}
.addGroupBtn {
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.65em;
  margin: 0;
  border-color: #53dac5;
  background-color: #53dac5;
  cursor: pointer;
  font-size: 0.75em;
  color: #fff;
  font-weight: bold;
}
.labelForSelect {
  display: block;
  line-height: 1.5;
  font-size: 0.9em;
  font-weight: 600;
  color: #5e5873;
  text-transform: none !important;
  margin-bottom: 0.4em;
}
.input-group-repeatable-remove {
  background-color: #cecece;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 1.35em;
  height: 1.35em;
  transition: background-color 0.2s;
}
.input-group-repeatable-remove:hover {
  background-color: #dc2c2c;
}

.input-group-repeatable-remove::before,
.input-group-repeatable-remove::after {
  content: "";
  position: absolute;
  left: 50%;
  width: 0.80em;
  height: 0.2em;
  background-color: white;
  transform-origin: center center;
  transition: transform 0.3s ease;
}

.input-group-repeatable-remove::before {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove::after {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove:hover::before {
  top: 42%;
  transform: translateX(-60%) rotate(45deg);
}

.input-group-repeatable-remove:hover::after {
  top: 42%;
  transform: translateX(-60%) rotate(-45deg);
}
.groupContainer {
  padding: 1em;
  border: 1px solid #efefef;
  border-radius: 0.3em;
}
.textHint {
  color: #6d6d6d;
  font-size: 0.8em;
  font-weight: 400;
  line-height: 1.5;
}
.text-error {
  color: #ec0303;
}
.btn-remove-group-horizontal {
  position: relative;
  color: transparent !important;
  margin: 0 0 0px 15px;
  border: 1px solid #e74c3c !important;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s;
}
.btn-remove-group-horizontal::after {
  content: "Eliminar";
  color: #fff;
  position: absolute;
  top: 4px;
  left: 12px;
  color: #e74c3c !important;
}
.btn-remove-group-horizontal:hover {
  background: #ffecec !important;
}
</style>